import { Component, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from '../../../shared/services/auth.service';
import { CreateUserComponent } from '../create-user/create-user.component';
import { ListUsersComponent } from '../list-users/list-users.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
})
export class UsersComponent {
  readonly createUserModule: string[] = [
    'app.dcr-portal.user-management.view',
    'app.dcr-portal.user-management.action.create',
    'app.dcr-portal.user-management.action.view',
    'app.dcr-portal.user-management.action.delete',
    'app.dcr-portal.user-management.action.edit',
  ];

  @ViewChild(ListUsersComponent) listUserComponent!: ListUsersComponent;

  constructor(
    public authService: AuthService,
    private nzModalService: NzModalService,
  ) {}

  openCreateUserModal(): void {
    this.nzModalService.create({
      nzContent: CreateUserComponent,
      nzFooter: null,
      nzClosable: true,
      nzTitle: 'Create User',
      nzMaskClosable: false,
      nzWidth: '50rem',
      nzOnOk: () => {
        this.listUserComponent.getUserList();
      },
    });
  }
}
